import React from "react";
import { Link } from "react-router-dom";

const MainLogo = () => {
    return (
        <Link to="/" className="site-logo">
            <img 
                src="/assets/img/logo/ibr_logo.webp" 
                alt="IBR Logo"
            />
        </Link>
    );
};

export default MainLogo;